import React from 'react'
import EditTableCell from '../Cell'

export default function EditTableRow({
    row,
    readOnly,
    index
}) {

    return (
        <div className={`table-row w-full items-center border-b border-line last:border-0 hover:bg-light ${index === 0 && 'rounded-t-lg overflow-hidden'}`} key={`row-${index}`}>

            {row?.map((cell, colIndex) => {       

                return (
                    <EditTableCell
                        cell={cell}
                        index={colIndex}
                        key={`row-${index}-cell-${colIndex}`}
                        readOnly={readOnly}
                    />
                )
            })}
        </div>
    )
}
